import React from "react";

export default function TaskCard({ t }: { t: any }) {
  return (
    <div className="border rounded p-4 shadow-sm bg-white space-y-1">

      <div className="flex justify-between">
        <div className="font-semibold">
          #{t.taskNo} — {t.taskName || "No Name"}
        </div>
        <span className="text-sm px-2 py-1 rounded bg-gray-200">
          {t.taskType}
        </span>
      </div>
 
      {t.taskGroupName && (
        <div className="text-sm text-gray-600">
          Group: <span className="font-medium">{t.taskGroupName}</span>
        </div>
      )}

      <div className="text-sm text-gray-700">
        Start: {t.startDate?.substring(0, 10)}  
        &nbsp;&nbsp; End: {t.endDate?.substring(0, 10)}
      </div>

      <div className="text-sm">
        Progress: <span className="font-medium">{t.progress}%</span>
      </div>

      <div className="text-sm text-gray-700">
        Closed Logs: {t.closedLogs} &nbsp;&nbsp;
        Postponed Logs: {t.postponedLogs}
      </div>

      {t.lastClosedDate && (
        <div className="text-sm text-green-700">
          Last Closed: {t.lastClosedDate.substring(0, 10)}
        </div>
      )}

      {t.lastDueDateChange && (
        <div className="text-sm text-blue-700">
          Last Due Change: {t.lastDueDateChange.substring(0, 10)}
        </div>
      )}
    </div>
  );
}
